import { Box, Typography, useTheme } from '@mui/material';

import { getMasterPhotoById } from '@/helpers/images-helper';

import ArieteIcon from '../shared/icons/recommendation-icons/ariete-icon';
import BufonIcon from '../shared/icons/recommendation-icons/bufon-icon';
import CapitanArieteIcon from '../shared/icons/recommendation-icons/capitan-ariete-icon';
import ChollosIcon from '../shared/icons/recommendation-icons/chollos-icon';
import RevulsivoIcon from '../shared/icons/recommendation-icons/revulsivo-icon';
import ImageBox from '../shared/player-box';
import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';

const EquipoRecomendacionJugadores = ({ players }) => {
    const getInfoIcon = (text) => {
        switch (text) {
            case 'Revulsivo':
                return <RevulsivoIcon />;
            case 'Ariete':
                return <ArieteIcon />;
            case 'Bufón':
                return <BufonIcon />;
            case 'Capitán':
                return <CapitanArieteIcon />;
            case 'Chollo':
                return <ChollosIcon />;
            default:
                return null;
        }
    };

    const renderPlayers = () => {
        const sections = [
            { title: 'Capitán', filterKey: 'isCapitan' },
            { title: 'Ariete', filterKey: 'isAriete' },
            { title: 'Chollo', filterKey: 'isChollo' },
            { title: 'Revulsivo', filterKey: 'isRevulsivo' },
            { title: 'Bufón', filterKey: 'isBufon' },
        ];

        if (players?.length > 0) {
            const allPlayers = sections.flatMap((section) => {
                return players
                    .filter((player) => player[section.filterKey])
                    .map((player) => ({ ...player, category: section.title }));
            });

            return (
                <Box display="flex" flexWrap="wrap" justifyContent="flex-start">
                    {allPlayers.map((player, index) => (
                        <Box
                            key={index}
                            style={{
                                width: '20%',
                                textAlign: 'center',
                                padding: '8px',
                            }}
                        >
                            <Box display="flex" alignItems="center" justifyContent="center" mt={1}>
                                {getInfoIcon(player.category)}
                                <Typography variant="caption" style={{ marginLeft: '4px', fontSize: '10px' }}>
                                    {player.category}
                                </Typography>
                            </Box>
                            <ImageBox
                                image={getMasterPhotoById(player?.information?.id)}
                                width={60}
                                height={60}
                                styles={{ marginBottom: '4px' }}
                            />
                            <Box>
                                <Typography fontSize={14}>{player?.information?.name}</Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            );
        }
    };

    return (
        <>
            <CustomSectionWrapper title="DonquiPicks" mt={2}>
                {renderPlayers()}
            </CustomSectionWrapper>
        </>
    );
};

export default EquipoRecomendacionJugadores;
